import { CHECK_ACTOR_VALENCY_MIGRATION } from '@control-front-end/common/constants/graphLayers';
import { RequestStatus } from 'constants';
import { createReducer } from '@reduxjs/toolkit';

// ------------------------------------
// Reducer
// ------------------------------------

const initState = {};

export default createReducer(initState, {
  [CHECK_ACTOR_VALENCY_MIGRATION.SUCCESS]: (state, action) => {
    const { actorId } = action.payload;
    if (!actorId) return state;

    const existingMigration = state[actorId];
    if (existingMigration?.status === RequestStatus.SUCCESS) {
      return state;
    }

    return {
      ...state,
      [actorId]: {
        ...(state[actorId] || {}),
        ...action.payload,
      },
    };
  },
});
